import { Divider } from '@material-ui/core';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import Stepper from '@material-ui/core/Stepper';
import Typography from '@material-ui/core/Typography';
import { Group } from '@visx/group';
import React, { useEffect, useState } from 'react';
import { SettingChoices, StepList, StepTranslations } from '../consts';
import { getStepNumber } from '../Data/StoryFunctions';

export default function SideBar(props: { currStep: SettingChoices, updateStep: Function, updateFilters: Function }) {
    const [activeStep, setActiveStep] = useState<SettingChoices>(props.currStep);
    const steps = StepList;

    useEffect(() => {
        if (props.currStep !== activeStep) {
            setActiveStep(props.currStep);
        }
    })

    const handleClick: any = (chosenLabel: SettingChoices) => {
        setActiveStep(chosenLabel)
        props.updateStep(chosenLabel);
    }


    return (
        <Group id="SideBar" style={{ display: "flex", flexDirection: "column" }}>
            <Group id="Stepper">
                <Stepper activeStep={getStepNumber(activeStep)} orientation="vertical">
                    {steps.map((label, index) => (
                        <Step key={label} style={{ cursor: "pointer" }}>
                            <StepLabel onClick={(e) => { handleClick(label) }}><Typography variant="button">{StepTranslations[label]}</Typography></StepLabel>
                        </Step>
                    ))}
                </Stepper>
            </Group>
            <Divider />
        </Group>
    );
}
